import React, { useMemo } from "react";
import { getVal } from "oolib";
import { ConfigForm_SectionWrapper } from "../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { DataFieldInputSelector } from "@/components/DataFieldInputSelector";
import { TitleInputWithDefault } from "../../utils/TitleInputWithDefault";
import { usePieChartConfig } from "./ConfigForm_Context";
import { DATA_KEYS } from "./DATA_KEYS";
import { CollapseTransition } from "../../utils/CollapseTransition";
import { NumberFieldConfig } from "../../WidgetBarChart/ConfigForm/NumberFieldConfig";
import TooltipV2 from "@/components/UI/Tooltip";

export const ConfigForm_ConfigureSection = () => {
  const { widgetConfig, dataKeys, setConfig, underEditWidgetIdx, arithmeticState } = usePieChartConfig();

  const {
    dataFields,
    hasMultipleFields,
    aggregateType,
    aggregateOptions,
    customExpression,
    validationError,
    handleAggregateChange,
    handleCustomExpressionChange,
  } = arithmeticState;

  const aggregateValue = useMemo(() => {
    const match = aggregateOptions.find(o => o.value === aggregateType);
    if (!match) return null;
    return { ...match, dataType: "Aggregate" };
  }, [aggregateOptions, aggregateType]);

  const isNumberInput = dataFields.A?.comp === 'NumberInput';
  const isVisible = hasMultipleFields || isNumberInput;

  return (
    <CollapseTransition isVisible={isVisible}>
      <ConfigForm_SectionWrapper icon="SlidersHorizontal" title="Configure Data">
        <CollapseTransition isVisible={hasMultipleFields}>
          <DataFieldInputSelector
            id={`${dataKeys.dimension1}-aggregate`}
            options={aggregateOptions}
            value={aggregateValue}
            onChange={handleAggregateChange}
            placeholder="Select Aggregate"
            placeholderIcon="MathOperations"
            trailingIcon="CaretRight"
          />
        </CollapseTransition>

        <CollapseTransition isVisible={hasMultipleFields && aggregateType === 'custom'}>
          <TooltipV2 text="Enter a custom expression for the aggregation" placement="right" wrapperDisplay="block">
            <TitleInputWithDefault
              id={`${dataKeys.dimension1}-custom-expr`}
              value={customExpression}
              onChange={handleCustomExpressionChange}
              placeholder="e.g., (A + B) - C"
              tagLabel="EXPRESSION"
              validationStatus={validationError ? { type: 'error', msg: validationError } : null}
            />
          </TooltipV2>
        </CollapseTransition>

        <NumberFieldConfig
          dimensionKey="dimension1"
          dimensionValue={getVal(widgetConfig, dataKeys.dimension1)}
          dataKeys={DATA_KEYS}
          thisWidgetConfig={widgetConfig}
          setConfig={setConfig}
          underEditWidgetIdx={underEditWidgetIdx}
        />
      </ConfigForm_SectionWrapper>
    </CollapseTransition>
  );
};
